import { render } from "./Management.vue?vue&type=template&id=10cecfa8"
import script from "./Management.vue?vue&type=script&lang=js"
export * from "./Management.vue?vue&type=script&lang=js"

import "./Management.vue?vue&type=style&index=0&id=10cecfa8&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__